document.addEventListener("DOMContentLoaded", function () {
  function updateSVGWidth() {
    document.querySelectorAll(".list-menu__item").forEach(item => {
      let hoverIcon = item.querySelector(".hover-icon");

      if (!hoverIcon) {
        hoverIcon = document.createElement("img");
        hoverIcon.classList.add("hover-icon");
        hoverIcon.src = "https://cdn.shopify.com/s/files/1/0790/6295/8411/files/project-hover2.svg?v=1739790437";
        hoverIcon.alt = "";
        item.appendChild(hoverIcon);
      }

      setTimeout(() => {
        const listItemWidth = item.offsetWidth;

        if (listItemWidth > 50) { 
          const paddedWidth = listItemWidth + 10;

          hoverIcon.setAttribute("style", `width: ${paddedWidth}px !important; height: 40px !important; display: block !important;`);

        }
      }, 50);
    });
  }

  updateSVGWidth();

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSVGWidth, 100);
  });
});
